import { useEffect, useState } from "react";
import {
  query,
  collection,
  orderBy,
  onSnapshot,
  where,
} from "firebase/firestore";
import { firebaseDB } from "../../firebase";
import { Transaction } from "../../types/budgethelper";
import { useUser } from "../../auth/userContext";

export const useGetTransactions = () => {
  const [transactions, setTransactions] = useState<Transaction[]>([]);
  const [transactionTotals, setTransactionTotals] = useState(0.0);
  const { userProfile, loading } = useUser();
  
  const transactionCollectionRef = collection(firebaseDB, "transactions");

  const getTransactions = async () => {
    let unsubscribe: () => void = () => {};
    try {
      if (!userProfile?.budgetGroups || userProfile.budgetGroups.length === 0) {
        setTransactions([]);
        setTransactionTotals(0);
        return () => {};
      }

      const queryTransactions = query(
        transactionCollectionRef,
        where("budgetGroup", "in", userProfile.budgetGroups),
        orderBy("timestamp", "desc")
      );

      unsubscribe = onSnapshot(queryTransactions, (snapshot) => {
        let docs: Transaction[] = [];
        let totalExpenses = 0;

        snapshot.forEach((doc) => {
          const data = doc.data();
          const id = doc.id;

          docs.push({ ...data, id } as Transaction);
          totalExpenses += data.amount;
        });

        setTransactions(docs);

        setTransactionTotals(totalExpenses);
      });
    } catch (err) {
      console.error(err);
    }

    return () => unsubscribe();
  };

  useEffect(() => {
    if (!userProfile || loading) return;
    const unsubscribe = getTransactions();
    return () => {
      unsubscribe.then(unsub => unsub());
    };
  }, [userProfile?.budgetGroups, loading]);

  return { transactions, transactionTotals };
};